var AssetType = (function () {
    function AssetType() {
    }
    return AssetType;
}());
export { AssetType };
AssetType.ENTITY = "entity";
AssetType.SKYBOX = "skybox";
AssetType.CAMERA = "camera";
AssetType.SEGMENT_SET = "segmentSet";
AssetType.MESH = "mesh";
AssetType.GEOMETRY = "geometry";
AssetType.SKELETON = "skeleton";
AssetType.SKELETON_POSE = "skeletonPose";
AssetType.CONTAINER = "container";
AssetType.TEXTURE = "texture";
AssetType.TEXTURE_PROJECTOR = "textureProjector";
AssetType.MATERIAL = "material";
AssetType.ANIMATION_SET = "animationSet";
AssetType.ANIMATION_STATE = "animationState";
AssetType.ANIMATION_NODE = "animationNode";
AssetType.ANIMATOR = "animator";
AssetType.STATE_TRANSITION = "stateTransition";
AssetType.LIGHT = "light";
AssetType.LIGHT_PICKER = "lightPicker";
AssetType.SHADOW_MAP_METHOD = "shadowMapMethod";
AssetType.EFFECTS_METHOD = "effectsMethod";
